import { FC, memo } from 'react'
import { IconName } from '@/client/components/Icon/types'
import * as S from './styles'
import { CardPackageProps } from './types'
import { List } from '../List/List'
import { ListItem } from '../List/ListItem'

export const CardPackageSimple: FC<CardPackageProps> = memo(
  ({ kind = 'dark', name, list, compactView = false, ...rest }) => (
    <S.Card kind={kind} {...rest}>
      <div>
        <S.CardHeader kind={kind}>{name}</S.CardHeader>

        <S.CardInfos>
          {!compactView && (
            <List>
              {list.map(({ icon, text, isBold }) => (
                <ListItem
                  key={text}
                  iconName={icon as IconName}
                  weight={isBold ? 'medium' : 'normal'}
                  fontSize='small'
                  className='list-icon'
                >
                  <span dangerouslySetInnerHTML={{ __html: text }} />
                </ListItem>
              ))}
            </List>
          )}
        </S.CardInfos>
      </div>
    </S.Card>
  )
)

CardPackageSimple.displayName = 'CardPackageSimple'
